import { useEffect, useState } from "react";

export function useUserShippingData(API_BASE, userId) {
  const [carriers, setCarriers] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!API_BASE || !userId) return;
    let abort = false;

    (async () => {
      setLoading(true);
      setError(null);
      try {
        const headers = { "Content-Type": "application/json" };
        const [resCarriers, resWarehouses] = await Promise.all([
          fetch(`${API_BASE}/api/CarrierAccounts/my?userId=${userId}`, {
            headers,
          }),
          fetch(`${API_BASE}/api/warehouses/my?userId=${userId}`, { headers }), // <— minuscule/majuscule OK en .NET, garde une seule forme
        ]);

        if (!resCarriers.ok)
          throw new Error(`GET carriers: ${resCarriers.status}`);
        if (!resWarehouses.ok)
          throw new Error(`GET warehouses: ${resWarehouses.status}`);

        const [carriersJson, warehousesJson] = await Promise.all([
          resCarriers.json(),
          resWarehouses.json(),
        ]);

        if (!abort) {
          setCarriers(Array.isArray(carriersJson) ? carriersJson : []);
          setWarehouses(Array.isArray(warehousesJson) ? warehousesJson : []);
        }
      } catch (e) {
        if (!abort) {
          setError(e?.message || "Erreur de chargement");
          setCarriers([]);
          setWarehouses([]);
        }
      } finally {
        if (!abort) setLoading(false);
      }
    })();

    return () => {
      abort = true;
    };
  }, [API_BASE, userId]);

  return { carriers, warehouses, loading, error };
}
